<template lang="pug">
	ul.navbar-nav
		li.nav-item.px-3
			a.nav-link.settings(href="#" target="_self")
				i.fa.fa-gear(v-if="Project.SelectedProject" @click="asideToggle")
</template>

<script>
	import { asideMenuCssClasses, validBreakpoints, checkBreakpoint } from '../../shared/classes'
	import toggleClasses from '../../shared/toggle-classes'

	import Screen from './../../mixins/screen';

	import { Layout } from './../../services/Layout'
	import { Template } from './../../services/Template'
	import { Settings } from './../../services/Settings'
	import { Project } from './../../services/Project'

	export default {
		name: 'SettingsToggler',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed"]
		},
		props: {
			defaultOpen: {
				type: Boolean,
				default: false
			},
			display: {
				type: String,
				default: ''
			},
			mobile: {
				type: Boolean,
				default: false
			},
		},
		data() {

			this.Template = Template;
			this.Settings = Settings;
			this.Project = Project;

			return {
				showed: true
			};

		},
		methods: {
			toggle (force) {
				const [display, mobile] = [this.display, this.mobile];
				let cssClass = asideMenuCssClasses[0];
				if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
					cssClass = `aside-menu-${display}-show`
				}
				Layout.asideOpened = !document.body.classList.contains(cssClass);
				toggleClasses(cssClass, asideMenuCssClasses, force);
				Broadcast.call('Aside State Changed');
			},
			asideToggle (e) {
				e.preventDefault();
				this.toggle();
			}
		}
	}
</script>

<style lang="sass" scoped>

	ul.navbar-nav
		list-style: none
		position: relative

		a.nav-link.settings
			font-size: 25px
			line-height: 23px

		.nav-link,
		.nav-link:focus
			color: #c8ced3

		.nav-link:hover
			color: #fff

</style>
